export const DOCUMENT_TABLE = {
  customer: 'Customer',
  vendor: 'Vendor',
} as const

export interface EntityDocument {
  id?: number
  tableName?: string
  tableRowId?: number
  documentName?: string
  documentPath?: string
  path?: string
  originalFileName?: string
  contentType?: string
  branchId?: number
  createdDate?: string
}
